import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { getDateTime } from "app/common/LocalFunction";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const ListStoreRequestItemPopup = ({ open, handleClose, initialData }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <PopupForm
      open={open}
      size="md"
      handleClose={handleClose}
      title={`Lịch sử xuất kho`}
      formik={{
        initialValues: initialData,

        enableReinitialize: true,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(() => {
  const { setFieldValue, values } = useFormikContext();
  const department = useDefaultDepartment();
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={values}
            // minWidth={"780px"}
            columns={[
              {
                field: "age",
                title: t("Ngày xuất"),
                render: (val) => getDateTime(val?.orderDate),
              },
              {
                field: "createDate",
                title: t("Ngày hệ thống"),
                render: (val) => getDateTime(val?.createDate),
              },

              { field: "request.depName", title: t("Cơ sở") },
              { field: "createdBy", title: t("Người tạo") },
              { field: "productName", title: t("Sản phẩm") },
              {
                field: "stockUnitName",
                title: t("Đơn vị tính"),
                render: (val) => val?.stockUnitName || val?.unit?.name || "",
              },
              {
                field: "quantity",
                title: t("Số lượng yêu cầu"),
                align: "right",
              },
              {
                field: "exportUnitName",
                title: t("Đơn vị xuất"),
                render: (val) => val?.exportUnitName || "",
              },
              {
                field: "coefficient",
                title: t("Trọng số"),
                align: "right",
                render: (val) =>
                  val?.coefficient != null ? val.coefficient : "",
              },
              {
                field: "exportedMinSkuQuantity",
                title: t("SL xuất (ĐV nhỏ nhất)"),
                align: "right",
                render: (val) =>
                  val?.exportedMinSkuQuantity != null
                    ? val.exportedMinSkuQuantity
                    : "",
              },
              // {
              //   field: "exportedQuantity",
              //   title: t("Số lượng xuất"),
              //   align: "right",
              // },
            ]}
          />
        </Grid>
      </Grid>
    </>
  );
});

export default memo(observer(ListStoreRequestItemPopup));
